<template>
  <div
    class="container nav-bg-upload"
    ref="container"
    :style="bgStyle"
  >
    <div
      class="left-over"
      v-if="value.left.fileId !== '-1'"
      :style="bgLeftStyle"
    ></div>
    <div
      class="right-over"
      v-if="value.right.fileId !== '-1'"
      :style="bgRightStyle"
    ></div>
    <el-row
      :gutter="0"
      class="auto-height"
    >
      <el-col
        :span="8"
        class="auto-height col hover-bg"
      >
        <el-upload
          v-if="value.left.fileId === '-1'"
          :action="uploadSrc"
          name="img"
          class="full-upload"
          :show-file-list="false"
          :data="leftUploadData"
          :on-success="leftUploadSuccess"
          :on-error="uploadFail"
          :before-upload="beforeUpload"
        >
          <div
            class="icon center"
            :class="{ 'new-cls': !hasBg }"
          >
            <i class="h-icon-add"></i>{{ $t("management.navigate.left_nav_title") }}
          </div>
        </el-upload>
        <div
          class="operator-wrapper"
          v-else
        >
          <div
            class="icon m-r"
            @click="removeImage('left')"
          >
            <i class="h-icon-delete"></i>{{ $t("common.removeBtn_text") }}
          </div>
          <el-upload
            :action="uploadSrc"
            name="img"
            :show-file-list="false"
            :data="middleUploadData"
            :on-success="leftUploadSuccess"
            :on-error="uploadFail"
            :before-upload="beforeUpload"
          >
            <div class="icon">
              <i class="h-icon-switch"></i>{{ $t("common.replaceBtn_text") }}
            </div>
          </el-upload>
        </div>
      </el-col>
      <el-col
        :span="8"
        class="auto-height col hover-bg"
      >
        <el-upload
          v-if="!hasBg"
          :action="uploadSrc"
          name="img"
          class="full-upload"
          :show-file-list="false"
          :data="middleUploadData"
          :on-success="middleUploadSuccess"
          :on-error="uploadFail"
          :before-upload="beforeUpload"
        >
          <div class="icon new-cls center">
            <i class="h-icon-add"></i>{{ $t("management.navigate.middle_nav_title") }}
          </div>
        </el-upload>
        <div
          class="operator-wrapper"
          v-else
        >
          <div
            class="icon m-r"
            @click="removeImage('middle')"
          >
            <i class="h-icon-delete"></i>{{ $t("common.removeBtn_text") }}
          </div>
          <el-upload
            :action="uploadSrc"
            name="img"
            :show-file-list="false"
            :data="middleUploadData"
            :on-success="middleUploadSuccess"
            :on-error="uploadFail"
            :before-upload="beforeUpload"
          >
            <div class="icon">
              <i class="h-icon-switch"></i>{{ $t("common.replaceBtn_text") }}
            </div>
          </el-upload>
        </div>
      </el-col>
      <el-col
        :span="8"
        class="auto-height col hover-bg"
      >
        <el-upload
          v-if="value.right.fileId === '-1'"
          :action="uploadSrc"
          name="img"
          class="full-upload"
          :show-file-list="false"
          :data="rightUploadData"
          :on-success="rightUploadSuccess"
          :on-error="uploadFail"
          :before-upload="beforeUpload"
        >
          <div
            class="icon center"
            :class="{ 'new-cls': !hasBg }"
          >
            <i class="h-icon-add"></i>{{ $t("management.navigate.right_nav_title") }}
          </div>
        </el-upload>
        <div
          class="operator-wrapper"
          v-else
        >
          <div
            class="icon m-r"
            @click="removeImage('right')"
          >
            <i class="h-icon-delete"></i>{{ $t("common.removeBtn_text") }}
          </div>
          <el-upload
            :action="uploadSrc"
            name="img"
            :show-file-list="false"
            :data="rightUploadData"
            :on-success="rightUploadSuccess"
            :on-error="uploadFail"
            :before-upload="beforeUpload"
          >
            <div class="icon">
              <i class="h-icon-switch"></i>{{ $t("common.replaceBtn_text") }}
            </div>
          </el-upload>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import configuration from 'api/config'
import API from 'api/api'
import { LoadingMixin } from 'utils/mixin'
export default {
  name: 'nav-bg-upload',
  model: {
    event: 'change'
  },
  props: {
    value: {
      type: Object,
      default () {
        return {
          left: {
            fileId: -1,
            path: '',
            width: '',
            height: ''
          },
          middle: {
            fileId: -1,
            path: '',
            width: '',
            height: ''
          },
          right: {
            fileId: -1,
            path: '',
            width: '',
            height: ''
          }
        }
      }
    }
  },
  computed: {
    uploadSrc () {
      return `${configuration.baseUrl}${configuration.uploadSrc}`
    },
    leftUploadData () {
      return {
        usageScenario: 'navigateBgImgLeft'
      }
    },
    middleUploadData () {
      return {
        usageScenario: 'navigateBgImgMiddle'
      }
    },
    rightUploadData () {
      return {
        usageScenario: 'navigateBgImgRight'
      }
    },
    bgStyle () {
      if (this.value.middle.fileId !== '-1') {
        return {
          'background-image': `url(${this.value.middle.path})`
        }
      } else {
        return {}
      }
    },
    bgLeftStyle () {
      if (this.value.left.fileId !== '-1') {
        return {
          width: `${this.value.left.width}px`,
          'background-image': `url(${this.value.left.path})`
        }
      } else {
        return {}
      }
    },
    bgRightStyle () {
      if (this.value.right.fileId !== '-1') {
        return {
          width: `${this.value.right.width}px`,
          'background-image': `url(${this.value.right.path})`
        }
      } else {
        return {}
      }
    },
    hasBg () {
      return this.value.middle.fileId !== '-1'
    }
  },
  data () {
    return {
      loadingInstance: null
    }
  },
  methods: {
    beforeUpload (file) {
      if (!/.(png|jpg|JPG|PNG)$/.test(file.name)) {
        this.$message.error(this.$t('common.image_type_error'))
        return false
      }
      this.loadingInstance = this._getLoading()
      API.common.keepAlive()
      return true
    },
    leftUploadSuccess (response, file) {
      this.loadingInstance && this.loadingInstance.close()
      if (response.code === '0') {
        this.$message.success(this.$t('common.upload_success'))
        let _params = JSON.parse(JSON.stringify(this.value))
        _params.left = {
          fileId: response.data.fileId,
          path: response.data.path,
          width: response.data.width,
          height: response.data.height
        }
        this.$emit('change', _params)
      } else {
        this.$message.error(response.msg)
      }
    },
    middleUploadSuccess (response, file) {
      this.loadingInstance && this.loadingInstance.close()
      if (response.code === '0') {
        this.$message.success(this.$t('common.upload_success'))
        let _params = JSON.parse(JSON.stringify(this.value))
        _params.middle = {
          fileId: response.data.fileId,
          path: response.data.path,
          width: response.data.width,
          height: response.data.height
        }
        this.$emit('change', _params)
      } else {
        this.$message.error(response.msg)
      }
    },
    rightUploadSuccess (response, file) {
      this.loadingInstance && this.loadingInstance.close()
      if (response.code === '0') {
        this.$message.success(this.$t('common.upload_success'))
        let _params = JSON.parse(JSON.stringify(this.value))
        _params.right = {
          fileId: response.data.fileId,
          path: response.data.path,
          width: response.data.width,
          height: response.data.height
        }
        this.$emit('change', _params)
      } else {
        this.$message.error(response.msg)
      }
    },
    uploadSuccess () {

    },
    uploadFail () {
      this.loadingInstance.close()
      this.$message.error(this.$t('common.upload_error'))
    },
    removeImage (type) {
      let _params = JSON.parse(JSON.stringify(this.value))
      _params[type] = {
        fileId: '-1',
        path: '',
        width: 0,
        height: 0
      }
      this.$emit('change', _params)
    }
  },
  mixins: [LoadingMixin]
}
</script>

<style scoped lang="less" rel="stylesheet/less">
.nav-bg-upload.container {
  width: 100%;
  height: 100%;
  background-repeat: repeat-x;
  position: relative;
  .left-over {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    background-repeat: no-repeat;
  }
  .right-over {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    background-repeat: no-repeat;
  }
  .auto-height {
    height: 100%;
    position: relative;
  }
  .col {
    &:hover {
      .operator-wrapper {
        display: block;
        color: rgba(255, 255, 255, 0.8);
      }
    }
    &.hover-bg:hover {
      background-color: rgba(0, 0, 0, 0.3);
    }
  }
  .operator-wrapper {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    color: rgba(0, 0, 0, 0.8);
    display: none;
  }
  .full-upload {
    width: 100%;
    height: 100%;
    color: rgba(0, 0, 0, 0.8);
    overflow: hidden;
    &:hover {
      color: rgba(255, 255, 255, 0.8);
    }
  }
  .icon {
    display: inline-block;
    padding: 4px;
    font-size: 12px;
    vertical-align: top;
    cursor: pointer;
    &.m-r {
      margin-right: 16px;
    }
    &.center {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
    }
    &:hover {
      color: rgba(255, 255, 255, 1);
    }
    i {
      font-size: 24px;
      display: inline-block;
      width: 16px;
      height: 16px;
      vertical-align: middle;
      position: relative;
      top: -6px;
      margin-right: 12px;
    }
  }
  .inner {
    height: 100%;
  }
}
</style>
